<!-- EntityConfigurationOCR -->
    <ion-col class="flex-align-center">
        <ion-grid>
            <ion-row>
                <ion-col size="12" class="ion-text-center">
                    <h3>Configurações de OCR</h3>
                </ion-col>
            </ion-row>

            <ion-row *ngFor="let item of config?.ConfigList">
                <ion-col size="12">
                    <ion-card>
                        <ion-card-header>
                            <ion-card-title>
                                {{ getOCRTypeName(item?.Type?.Id) }}
                                <ion-badge color="primary">
                                    {{ item?.Module?.Name }}
                                </ion-badge>
                            </ion-card-title>
                        </ion-card-header>

                        <ion-card-content>
                            <!-- Informações Básicas -->
                            <ion-row>
                                <ion-col size="12">
                                    <ion-item lines="none">
                                        <ion-icon name="information-circle-outline" slot="start"></ion-icon>
                                        <ion-label><strong>ID:</strong> {{ item?.Id }}</ion-label>
                                    </ion-item>
                                </ion-col>
                            </ion-row>

                            <ion-row>
                                <ion-col size="6">
                                    <ion-item lines="none">
                                        <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                        <ion-label><strong>Criado em:</strong> {{ item?.CreateDate | date:'medium' }}</ion-label>
                                    </ion-item>
                                </ion-col>
                                <ion-col size="6">
                                    <ion-item lines="none">
                                        <ion-icon name="person-outline" slot="start"></ion-icon>
                                        <ion-label><strong>Criado por:</strong> {{ item?.CreateUser }}</ion-label>
                                    </ion-item>
                                </ion-col>
                            </ion-row>

                            <!-- Tipo de OCR -->
                            <ion-row>
                                <ion-col size="12">
                                    <ion-item lines="none">
                                        <ion-icon name="document-text-outline" slot="start"></ion-icon>
                                        <ion-label>
                                            <strong>Tipo de OCR:</strong>
                                            <ion-badge color="secondary">{{ item?.Type?.Name }}</ion-badge>
                                        </ion-label>
                                    </ion-item>
                                </ion-col>
                            </ion-row>

                            <!-- Módulo -->
                            <ion-row>
                                <ion-col size="12">
                                    <ion-item lines="none">
                                        <ion-icon name="cube-outline" slot="start"></ion-icon>
                                        <ion-label>
                                            <strong>Módulo:</strong>
                                            <ion-badge color="tertiary">{{ item?.Module?.Name }}</ion-badge>
                                            <span class="module-id">(ID: {{ item?.Module?.Id }})</span>
                                        </ion-label>
                                    </ion-item>
                                </ion-col>
                            </ion-row>

                            <!-- Configurações específicas por tipo -->
                            <ion-row *ngIf="item?.Type?.Id === '1'">
                                <ion-col size="12">
                                    <ion-item lines="none">
                                        <ion-icon name="search-outline" slot="start"></ion-icon>
                                        <ion-label>
                                            <strong>Identificadores de Fatura:</strong>
                                            <p>Esta configuração define os padrões para identificação de faturas no módulo {{ item?.Module?.Name }}.</p>
                                        </ion-label>
                                    </ion-item>
                                </ion-col>
                            </ion-row>

                            <ion-row *ngIf="item?.Type?.Id === '2'">
                                <ion-col size="12">
                                    <ion-item lines="none">
                                        <ion-icon name="ban-outline" slot="start"></ion-icon>
                                        <ion-label>
                                            <strong>Lista Negra:</strong>
                                            <p>Esta configuração contém termos ou padrões que devem ser ignorados no processamento OCR para o módulo {{ item?.Module?.Name }}.</p>
                                        </ion-label>
                                    </ion-item>
                                </ion-col>
                            </ion-row>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-col>